/*
 * Ryan O'Dowd
 * 2019-05-28
 * © Copyright 2019 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({fonts, globalScale}) => {
  return {
    minorTitle: {
      marginTop: globalScale * 8,
      marginBottom: 0,
      fontFamily: fonts.primaryBold,
      fontSize: globalScale * 14,
    },
    dialog: {
      textAlign: 'left',
    },
    bold: {
      fontFamily: fonts.primaryBold,
    },
    copyright: {
      textAlign: 'right',
    },
    list: {
      marginBottom: globalScale * 8,
    },
    listItem: {
      marginVertical: globalScale * 4,
      marginLeft: globalScale * 32,
      // @TODO: add a list item icon?
    },
  };
};

export default getStyles;
